<template>
	<div class="sub-container">
		<div class="info_container" style="flex-direction: column;">
			<div class="academy-intro">
				<div class="tit">
					We Are Great Pro! <br />
					금융 IT프로 교육의 새로운 세계로 들어오세요.
					<span>
						소수 초정예를 위한 <br />
						금융 IT 무료 부트캠프, <br />
						'위대한 고래'<br />
						특별한 기회에 초대합니다.
					</span>
				</div>
				<img src="/images/academy-img.png" class="img">
			</div>
			<div class="academy-class">
				<div class="inner">
					<div class="tit">
						그레이트 프로의 <br />
						금융 IT 무료 부트캠프, <br />
						'위대한 고래' <br />
						커리어도 보상도 특별합니다.
					</div>
					<div class="point">
						<div>
							국내 최초! 금융 비즈니스 통찰 교육
							<span>
								IT 개발 기술의 숙련도만으로는 부족합니다. 이제는 퀄리티 개발자 시대! <br />
								국내 최초로 금융 비즈니스와 금융 도메인의 통찰을 갖추게 해드리는  ’퀄리티 개발자 교육’입니다.
							</span>
						</div>
						<div>
							국내 톱 레벨! 금융 IT 현장 시뮬레이션 실전 교육
							<span>
								실제 금융 IT 현장을 그대로 재현한 개발 환경에서 실전 기술과 협업 도구의 실력을 강화,<br />
								금융 프로젝트의 실전 기술을 완벽하게 구사할 수 있습니다.
							</span>
						</div>
						<div>
							그레이트 프로만이 보유한 교육 시스템
							<span>
								그레이트 프로만이 보유한 ‘IT 지식관리 시스템’,  ‘금융 IT 실전 교육 시스템’ <br />
								금융 IT 현장이 즉시 필요로 하는 완벽한 실력을 갖춘 금융 IT 프로를 배출합니다.
							</span>
						</div>
						<div>
							금융 IT 성공신화를 만들어 온 레전드 강사진
							<span>
								우리나라 대표 금융기관들의 수많은 프로젝트 성공 신화를 만들어온 주역들로 구성된 <br />
								레전드 강사진들의 현장 위주, 실전 위주 교육 프로그램으로 구성되어 있습니다.
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="academy-class">
				<div class="inner">
					<div class="tit sub">
						금융 IT 무료 부트캠프 <br />
						'위대한 고래' 교육 로드맵
					</div>
				</div>
				<div class="inner2">
					<div>
						금융 도메인 <br />
						통찰
					</div>
					<span></span>
					<div>
						금융 지식 <br />
						기술
					</div>
					<span></span>
					<div>
						금융 실전 <br />
						실습
					</div>
					<span></span>
					<div>
						금융 커리어 <br />
						얼라이언스
					</div>
				</div>
			</div>

			<div class="academy-class">
				<div class="inner">
					<div class="tit sub">
						그레이트 프로가 독자적으로 보유한 <br/>
						'금융 IT 실전교육 프로그램'으로 최고 역량의 IT 프로를 탄생시킵니다.
					</div>
				</div>
				<div class="greatpro-edu">
					<div class="inner">
						<div class="edu-box">
							1. 금융 IT 지식관리 시스템
							<span>
								금융 업무 지식과 시스템 구조, <br/>
								프로젝트 경험, 최고의 개발 기술을 <br/>
								통합했습니다.
							</span>
						</div>
						<div class="flex sp-tw" style="width: 900px;">
							<div class="edu-box">
								2. 금융 IT 실전 실습 시스템
								<span>
									실제 금융기관에서 사용하는<br/>
									고객, 수신, 여신 등 뱅킹 시스템을<br/>
									실전처럼 실습할 수 있습니다.
								</span>
							</div>
							<div class="edu-box">
								3. 레전드 전문가 멘토링
								<span>
									금융 시스템 구축 성공신화의 주역,<br/>
									금융 IT 레전드 전문가들이 <br/>
									최고의 실무 노하우를 코칭합니다. 
								</span>
							</div>
						</div>
						<div class="edu-box">
							4. AI 에이전트
							<span>
								반복적 개발, 테스트, 문서화 등 <br/>
								금융 IT 업무를 AI와 협업하는 <br/>
								코파일럿 시스템을 체득합니다.  
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="academy-class">
				<div class="inner">
					<div class="tit sub">
						선발 과정
					</div>
				</div>
				<div class="inner3">
					<div>
						멤버십 <br />
						활동 평가
					</div>
					<span></span>
					<div>
						기초 역량 <br />
						테스트
					</div>
					<span></span>
					<div>
						동기 <br />
						면접
					</div>
					<span></span>
					<div>
						서약서 <br />
						작성
					</div>
				</div>
				<div class="flex inner4">
					<div>
						‘위대한 고래’ 블로그 <br />
						멤버십 활동 3개월 이상 
					</div>
					<div>
						온라인 테스트
					</div>
					<div>
						화상 혹은 오프라인
					</div>
					<div>
						보안 및 지식재산권
					</div>
				</div>
			</div>

			<div class="academy-class">
				<div class="inner">
					<div class="tit sub">
						교육 장소
					</div>
				</div>
				<div class="inner pr-7">
					<div class="flex sp-tw edu-loc">
						<div>
							서울특별시 영등포구 국회대로 76길, 18  8층<br />
							<span>국회의사당역 1번 출구 도보 7분 거리</span>
						</div>
						<div>
							&#9724; 그레이트 프로 아카데미
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {gsap, CSSPlugin, ScrollTrigger} from 'gsap/all';
import { academyMeta } from '@/utils/meta';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSPlugin);

export default {
	metaInfo : academyMeta,
    components: {
        
    },
	data() {
		return {
		   videoList : ['test1.mp4', 'test2.mp4', 'test3.mp4'],
		   nowVideo : '',
		   videoIdx : 0,

		   lastScrollTop : 0,
		   headerVisible : true, // 스크롤에 따른 헤더 노출여부
		}
	},
	beforeMount(){
	},
    created() {
    },

	mounted : function() {
		this.scrollAnimation();
		this.videoPlayer('start');

		window.addEventListener('scroll', this.onScroll);
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},

	methods: {
		onScroll () { // 스크롤에 따른 헤더 노출
			if(screen.width < 1024){
				const delta = 15;
				var tmpLastScrollTOP = this.lastScrollTop;
				var curScrollTOP = document.documentElement.scrollTop; // 현재 스크롤 위치
				
				if(Math.abs(tmpLastScrollTOP - curScrollTOP) <= delta) return;

				if((curScrollTOP > 150) && (curScrollTOP > tmpLastScrollTOP) && (tmpLastScrollTOP > 0)) {
					this.headerVisible = false;
				} else{
					this.headerVisible = true;
				}

				this.lastScrollTop = curScrollTOP;
			}
		},
		videoPlayer(val) {
			switch(val) {
				case 'next' : 
					if(this.videoIdx == this.videoList.length-1) {
						this.videoIdx = 0;	
					} else {
						this.videoIdx++;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				case 'prev' :
					if(this.videoIdx == 0) {
						this.videoIdx = this.videoList.length-1;	
					} else {
						this.videoIdx--;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				default : 
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
				}
		},
		btnClick(val) {
			if(val == 'next') {
				this.videoPlayer('next');
			} else if(val == 'prev') {
				this.videoPlayer('prev');
			}
		},
		scrollAnimation(){
			// 작업중
			const $scrollBox1 = this.$refs.intro_box1;
			const $roundBox1 = this.$refs.round_box1;
			const $roundBox2 = this.$refs.round_box2;
			const intro_box2 = gsap.utils.toArray('.intro-box2');
			const $roundBox3 = this.$refs.round_box3;
			const $scrollBox2 = this.$refs.intro_box4;
			const p_box = gsap.utils.toArray('.p-box');
			
			gsap.fromTo(
				$scrollBox1, // 이벤트 적용 위치
				{ x: 1200 }, // 시작위치
				{ 
					x : 0,
					scrollTrigger : {
						trigger : $scrollBox1,
						start : "top bottom",
						end : "top top",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			gsap.fromTo(
				$roundBox1,
				{ x : 0 },
				{ 
					x : -1200,
					scrollTrigger : {
						trigger : $roundBox1,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			gsap.fromTo(
				$roundBox2,
				{ x : 0 },
				{ 
					x : 1300,
					scrollTrigger : {
						trigger : $roundBox2,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			intro_box2.forEach(box => {
				gsap.fromTo(
					box, 
					{ x : 1200 , opacity : 0},
					{
						x : 0,
						opacity : 1,
						scrollTrigger : {
							trigger : box,
							start : "top 80%",
							end : "90% bottom",
							scrub : true,
							// markers : true,
						}
					}
					);
			});

			gsap.fromTo(
				$roundBox3,
				{ x : 0 },
				{ 
					x : -1500,
					scrollTrigger : {
						trigger : $roundBox3,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			);

			gsap.fromTo(
				$scrollBox2, // 이벤트 적용 위치
				{ x: -1200, opacity : 0 }, // 시작위치
				{ 
					x : 0,
					opacity : 1,
					scrollTrigger : {
						trigger : $scrollBox2,
						start : "top bottom",
						end : "70% 80%",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			p_box.forEach(box => {
				// gsap.from( box, { 
				// 		scrollTrigger : box,
				// 		duration : 1,
				// 		autoAlpha : 0,
				// 		scale : 1.5,
				// 		width : 0,
				// 		start : 'top 90%',
				// 		// end : "top 90%",
				// 		// stagger : 0.07,
				// 		// markers : true,
				// 		// rotation : -80,
				// 		// skew: 90,
				// 		// ease : 'power1.easeNone'
				// 	}
				// );
				let box_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : box,
						start : 'top 95%',
						// markers : true,
					}
				});
				box_timeLine.from(box, {
						duration : 1,
						autoAlpha : 0,
						scale : 1.5,
						width : 0,
				});
			});


			/********** [ MOBILE ] **********/
			 /* 3. 텍스트 영역 */
			const m_intro_box_list = gsap.utils.toArray('.m-intro-box');

			m_intro_box_list.forEach(element => {
				const mIntroBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
						
					}
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-tit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-subtit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-cont'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-button'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});

			});

			/* 5. 포인트 영역 */
			const m_point_box_list = gsap.utils.toArray('.m-point-box');

			m_point_box_list.forEach(element => {
				const mPointBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
					}
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-tit'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-cont'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
			});
			
		}

	},
};
</script>